"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Versioning_1 = require("../versioning/Versioning");

var WebSocketReadyState_1 = require("./WebSocketReadyState");

var DefaultWebSocketAdapter = /*#__PURE__*/function () {
  function DefaultWebSocketAdapter(logger) {
    _classCallCheck(this, DefaultWebSocketAdapter);

    this.logger = logger;
  }

  _createClass(DefaultWebSocketAdapter, [{
    key: "create",
    value: function create(url, protocols, isSignedUrl) {
      this.connection = new WebSocket(isSignedUrl ? url : Versioning_1.default.urlWithVersion(url), protocols);
      this.connection.binaryType = 'arraybuffer';
    }
  }, {
    key: "send",
    value: function send(message) {
      var _this = this;

      if (!this.connection) {
        this.logger.error('WebSocket not yet created or already destroyed.');
        return false;
      }

      try {
        if (message instanceof Uint8Array) {
          this.connection.send(message.buffer);
        } else {
          this.connection.send(message);
        }

        return true;
      } catch (err) {
        this.logger.debug(function () {
          return "send error: ".concat(err.message, ", websocket state=").concat(WebSocketReadyState_1.default[_this.readyState()]);
        });
        return false;
      }
    }
  }, {
    key: "close",
    value: function close(code, reason) {
      var _a;

      (_a = this.connection) === null || _a === void 0 ? void 0 : _a.close(code, reason);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.connection = undefined;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(handler, eventListener) {
      /* istanbul ignore if */
      if (!this.connection) {
        this.logger.warn('Cannot add event listener with no WebSocket connection.');
        return;
      }

      this.connection.addEventListener(handler, eventListener);
    }
  }, {
    key: "readyState",
    value: function readyState() {
      if (!this.connection) {
        return WebSocketReadyState_1.default.None;
      }

      switch (this.connection.readyState) {
        case WebSocket.CONNECTING:
          return WebSocketReadyState_1.default.Connecting;

        case WebSocket.OPEN:
          return WebSocketReadyState_1.default.Open;

        case WebSocket.CLOSING:
          return WebSocketReadyState_1.default.Closing;

        case WebSocket.CLOSED:
          return WebSocketReadyState_1.default.Closed;
      }
    }
  }]);

  return DefaultWebSocketAdapter;
}();

exports.default = DefaultWebSocketAdapter;